import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import flags from "react-phone-number-input/flags";
import CountrySelect from "@/components/CountrySelect";

export { isValidPhoneNumber };

/**
 * The phone/WhatsApp input used across the site -- homepage lead forms, the
 * course-enroll lead form, the custom payment page -- as a single shared
 * component so every phone field renders through the exact same code path
 * instead of several near-identical inline PhoneInput usages that could
 * drift apart (and did: the payment page's own copy showed the selected
 * country's flag clipped in some browsers where this one doesn't).
 *
 * countrySelectComponent swaps in CountrySelect.jsx -- a custom searchable
 * dropdown -- in place of react-phone-number-input's default country
 * picker, which opens the browser/OS's own unstyled native <select>
 * popup. Being the single shared component, this one swap covers every
 * country picker on the site. Same value/onChange contract either way --
 * UI only, no behavior change.
 */
export default function PhoneField({
  id,
  testId,
  value,
  onChange,
  country,
  onCountryChange,
  placeholder = "Enter phone number",
  dark = false,
  hasError = false,
  ariaRequired,
}) {
  return (
    <div className={`zt-phone-input ${dark ? "zt-phone-dark" : ""} ${hasError ? "zt-phone-error" : ""}`}>
      <PhoneInput
        id={id}
        data-testid={testId}
        international
        flags={flags}
        withCountryCallingCode
        countrySelectComponent={CountrySelect}
        country={country}
        onCountryChange={(c) => onCountryChange(c || country)}
        countryCallingCodeEditable={false}
        defaultCountry="US"
        value={value}
        onChange={(val) => onChange(val || "")}
        placeholder={placeholder}
        autoComplete="tel"
        aria-required={ariaRequired}
        aria-invalid={hasError}
      />
    </div>
  );
}
